module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Spatula-fa1affb6f98992116651d99b411274ab.svg";